/**
 * Whether a client goal should appear on a calendar Plan day (YYYYMMDD int).
 */
export function isTargetGoalVisibleOnDay(goal, dayKeyInt) {
  if (goal.utcStartDate > dayKeyInt) return false;

  if (goal.completed) {
    if (!goal.utcCompletedDate) return false;
    if (dayKeyInt > goal.utcCompletedDate) return false;
    if (goal.utcTargetDate != null) {
      return goal.utcTargetDate === dayKeyInt;
    }
    return true;
  }

  if (goal.utcTargetDate == null) return true;
  return goal.utcTargetDate === dayKeyInt;
}
